// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"cH","newscontentBox":"cH"};